let actions = {
	GET_IMAGE({commit}, params) {
        return axios.get('/image', {params}).then(function (response) {
			commit('SET_IMAGE', response.data);
        }).catch(err => {
            console.log(err)
        })
    },
	SELECT_IMAGES({commit}, params) {
    	commit('SET_IMAGES', []);
		commit('SET_SELECTED_IMAGE_IDS', []);
		
        axios.get('/selectImages', {params}).then(function (response) {
			commit('SET_IMAGES', response.data)
        }).catch(err => {
            console.log(err)
        })
	},
	SELECT_REPORTED_IMAGES({commit}) {
        axios.get('/reportedImages').then(function (response) {
			commit('SET_IMAGES', response.data)
        }).catch(err => {
            console.log(err)
        })
	},
	SELECT_DOC({commit}, params) {
		commit('SET_PAGES', []);
		
        axios.get('/selectDocument', {params}).then(function (response) {
			commit('SET_PAGES', response.data)
        }).catch(err => {
            console.log(err)
        })
    },
    GET_PAGE ({commit}, params) {
        return axios.get('/getPage', {params}).then(function (response) {
			commit('SET_PAGE', response.data)
        }).catch(err => {
            console.log(err)
        })
    },
    GLOBAL_SEARCH({commit, state}) {
    	if(state.cancelSourceForSearch) {
    		state.cancelSourceForSearch.cancel('Cancelling the previous search request because a new request was sent.');
		}
    	
    	commit('SET_CANCEL_SOURCE_FOR_SEARCH', axios.CancelToken.source());
    	
        return axios.post('/globalSearch', state.searchParams, {
    		cancelToken: state.cancelSourceForSearch.token
    	}).then(response => {
        	commit('SET_IMAGES', response.data.images)
            commit('SET_PAGES', response.data.pages)
            commit('SET_IS_SEARCHED_FLAG', true);
        	commit('SET_IS_SEARCHING_FLAG', false);
        	commit('SET_CANCEL_SOURCE_FOR_SEARCH', null);
        }).catch(err => {
            console.log(err)
        })
    },
    IMAGE_SEARCH({commit, state}) {
    	if(state.cancelSourceForSearch) {
    		state.cancelSourceForSearch.cancel('Cancelling the previous search request because a new request was sent.');
		}
    	
    	commit('SET_CANCEL_SOURCE_FOR_SEARCH', axios.CancelToken.source());
    	
        return axios.post('/imageSearch', state.searchParams, {
        	cancelToken: state.cancelSourceForSearch.token
        }).then(response => {
        	commit('SET_IMAGES', response.data.images)
        	commit('SET_CANCEL_SOURCE_FOR_SEARCH', null);
        }).catch(err => {
            console.log(err)
        })
    },
    PAGE_SEARCH({commit, state}) {
    	if(state.cancelSourceForSearch) {
    		state.cancelSourceForSearch.cancel('Cancelling the previous search request because a new request was sent.');
		}
    	
    	commit('SET_CANCEL_SOURCE_FOR_SEARCH', axios.CancelToken.source());
    	
        return axios.post('/pageSearch', state.searchParams, {
        	cancelToken: state.cancelSourceForSearch.token
        }).then(response => {
        	commit('SET_PAGES', response.data.pages)
        	commit('SET_CANCEL_SOURCE_FOR_SEARCH', null);
        }).catch(err => {
            console.log(err)
        })
    },
}

export default actions